import React, { createContext, useContext } from "react";

// project-imports
import { showToast } from "../components/sweet-alert/Sweetalert";
import { postSubmitEnquiry } from "./salesforce_api_context";
import { GET_ENQUIRY_BEGIN, GET_ENQUIRY_FAILURE, GET_ENQUIRY_SUCCESS } from "../constants/actions";
import { useBugContext } from "./bug_context";

// third-party
import { useDispatch, useSelector } from "react-redux";

// Create context
export const EnquiryContext = createContext();

export const EnquiryProvider = (props) => {

  // Reading store data
  const enquiryState = useSelector((state) => state.enquiry);

  const { bugReportApi } = useBugContext();

  // Reading dispatch from Store
  const enquiryDispatch = useDispatch();

  // Constant function

  // Function to handle submit enquiry
  const submitEnquiry = async (enquiryParam) => {
    try {

      // Dispatching the action to begin  the api calling process
      enquiryDispatch({ type: GET_ENQUIRY_BEGIN, payload: true });

      // Calling API to post enquriy
      let enquiryData = await postSubmitEnquiry(enquiryParam);

      // Dispatching the actions on success
      enquiryDispatch({ type: GET_ENQUIRY_SUCCESS, payload: enquiryData });

      // Showing the toast message on enquiry submit successfully
      showToast("success", "Your enquiry is submitted Successfully", true, "bottom-right", false, true, 5000);
    } catch (error) {
      console.log("40 : enquiry_context : Error while submitting enquiry::", error && JSON.stringify(error));

      // Dispatching the actions on error
      enquiryDispatch({ type: GET_ENQUIRY_FAILURE, payload: error && error.message, });

      bugReportApi("Error while submit Enquiry", `/services/apexrest/enquiry`, "POST", error);

      // Showing the toast message on enquiry submit unsuccessfully
      showToast("error", error && error.message ? "We are unable to submit your enquiry at this moment. Please try again later!" : "An error occurred", true, "bottom-right", false, true, 5000);
    }
  };

  return (
    <EnquiryContext.Provider value={{ ...enquiryState, submitEnquiry }}>
      {props.children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiryContext = () => {
  return useContext(EnquiryContext);
};
